<template>
  <div class="w100m">
    <div class="footer-container" v-if="$store.state.isPc">
      <div class="footer-content flexHBC" >
        <div class="left flexH">
          <div class="fast-box">
            <div class="fast-title">快速入口</div>
            <div class="fast-nav marB10" v-for="item in footerList" @click="navChild(item.path,item.query, item.index,item.child)">{{item.title}}</div>
          </div>
          <div class="fast-box" style="margin-left: 100px;">
            <div class="fast-title"></div>
            <div class="fast-nav marB10" v-for="item in footerList2" @click="navChild(item.path,item.query, item.index,item.child)">{{item.title}}</div>
          </div>
          <div class="fast-box" style="margin-left: 100px;">
            <div class="fast-title">趁早（北京）科技有限公司</div>
            <div class="fast-nav marB10">电话：010-87778867</div>
            <div class="fast-nav marB10">邮箱：chenzao@chenzao.cn</div>
          </div>
        </div>

        <div class="right">
          <img src="../assets/images/icon_logo.svg" class="footer-logo marB30"/>
          <div class="flexHC">
            <div class="share-img " v-for="(item,index) in footerShare">
              <img :src="item.imgUrl" class="share-img-icon marR20"  @mouseenter="moreEnter(index)"
                   @mouseleave="moreLeave(index)">
              <img :src="item.code" class="share-code" v-show="item.isShow">
            </div>
          </div>
        </div>

      </div>
      <div class="footer-icp">
        <div style="margin-right: 7.71vw;">京ICP备13028391 | 增值电信业务经营许可证B2-20171813</div>
      </div>
    </div>
    <div class="footer-container-m " v-if="!$store.state.isPc">
      <div class="footer-content-m pR flexVC">
        <div class="title-m">快速入口</div>
        <div class="w100m flexWrap2">
          <div class="fast-nav-m  marT15" v-for="item in footerListMobile" @click="navChild(item.path,item.query, item.index,item.child)">{{item.title}}</div>
        </div>
        <div class="title-m marB10">趁早（北京）科技有限公司</div>
        <div class="fast-nav-m marB10">电话：010-87778867</div>
        <div class="fast-nav-m marB10">邮箱：chenzao@chenzao.cn</div>

        <div class="bottom-share flexHC">
          <img src="../assets/images/icon_logo.svg" class="footer-logo-m "/>
          <div class="flexHC">
            <div class="share-img " v-for="(item,index) in footerShare">
              <img :src="item.imgUrl" class="share-img-icon-m marR80R"  @mouseenter="moreEnter(index)"
                   @mouseleave="moreLeave(index)">
              <img :src="item.code" class="share-code" v-show="item.isShow">
            </div>
          </div>
        </div>
      </div>
      <div class="footer-mask-m flexHC2">京ICP备13028391 | 增值电信业务经营许可证B2-20171813</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data() {
      return {
        footerListMobile: [{
          title: '趁早计划',
          path: '/collegeDetail',
          index: 1,
          child: 0,
          query: {
            type: 1,
            index: 1
          },
        }, {
          title: '趁早课程',
          path: '/collegeDetail',
          index: 1,
          child: 1,
          query: {
            type: 2,
            index: 2
          },
        }, {
          title: '用户协议',
          path: '/agreement',
          index: 5,
          child: 0,
          query: {
            index: 1
          },
        },{
          title: '关于我们',
          index: 5,
          child: 0,
          path: '/about',
          query: {
            index: 1
          },
        }, {
          title: '加入我们',
          index: 5,
          child: 3,
          path: '/aboutJoinUs',
          query: {
            index: 4
          },
        }, {
          title: '商务合作',
          index: 5,
          child: 2,
          path: '/aboutBusiness',
          query: {
            index: 3
          },
        }],
        footerList: [{
          title: '趁早计划',
          path: '/collegeDetail',
          index: 1,
          child: 0,
          query: {
            type: 1,
            index: 1
          },
        }, {
          title: '趁早课程',
          path: '/collegeDetail',
          index: 1,
          child: 1,
          query: {
            type: 2,
            index: 2
          },
        }, {
          title: '用户协议',
          path: '/agreement',
          index: 5,
          child: 0,
          query: {
            index: 1
          },
        }],
        footerList2: [{
          title: '关于我们',
          index: 5,
          child: 0,
          path: '/about',
          query: {
            index: 1
          },
        }, {
          title: '加入我们',
          index: 5,
          child: 3,
          path: '/aboutJoinUs',
          query: {
            index: 4
          },
        }, {
          title: '商务合作',
          index: 5,
          child: 2,
          path: '/aboutBusiness',
          query: {
            index: 3
          },
        }],
        footerShare: [{
          imgUrl: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bottom_weibo.png',
          code: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/cion_bottom_webo_code.png',
          isShow: false,
        }, {
          imgUrl: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bottom_weixin.png',
          code: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/cion_bottom_weixin_code.jpg',
          isShow: false,
        }, {
          imgUrl: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bottom_douyin.png',
          code: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/cion_bottom_douyin_code.jpg',
          isShow: false,
        }, {
          imgUrl: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_bottom_xiaohongshu.png',
          code: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/about/icon_code_xiaohongshu.jpg',
          isShow: false,
        },],
      }
    },

    methods: {
      navChild(path,query = {},index,child){
        console.log(path)
        this.$store.commit('edit', child)
        this.$store.commit('editIndex', index)
        this.$router.push({
          path: path,
          query: query
        })
      },
      moreEnter(index) {
          this.footerShare[index].isShow = true
      },
      moreLeave(index) {
          this.footerShare[index].isShow = false
      },
    }
  }
</script>

<style scoped>

  .footer-container {
    width: 100%;
    height: 316px;
  }

  .footer-content {
    width: 100%;
    height: 238px;
    background: #F7F8F9;
  }

  .footer-icp{
    width: 100%;
    height: 78px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
  }

  .left {
    height: 138px;
    padding-left: 7.71vw;
  }

  .right {
    margin-right: 7.71vw;
    height: 138px;
  }

  .fast-title {
    height: 20px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    margin-bottom: 30px;
  }

  .fast-nav {
    font-size: 13px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.64);
    cursor: pointer;
  }

  .footer-logo{
    width: 42px;
    height: 20px;
  }

  .share-img{
    position: relative;
  }

  .share-img-icon{
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  .share-code{
    width: 120px;
    height: 120px;
    position: absolute;
    top: -140px;
    left: -60px;
  }

  /**********************************  移动端********************************************/
  .footer-container-m{
    width: 100%;
    height: 8.24rem;
  }

  .footer-content-m{
    width: 100%;
    height: 7.38rem;
    background: #F7F8F9;
  }

  .title-m{
    font-size: 0.28rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 0.8rem;
  }

  .fast-nav-m {
    width: 50%;
    font-size: 0.26rem;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
    text-align: center;
  }

  .bottom-share{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0.50rem;
  }

  .footer-logo-m{
    width: 0.79rem;
    height: 0.38rem;
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }

  .footer-mask-m{
    width: 100%;
    height: 0.86rem;
    font-size: 0.22rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    background: #f0f2f5;
  }

  .share-img-icon-m{
    width: 0.48rem;
    height: 0.48rem;
    cursor: pointer;
  }

  .marR80R{
    margin-right: 0.65rem;
  }

  /*  *************************************************************************************/

</style>



// WEBPACK FOOTER //
// src/components/ShapeFooter.vue